import { useQuery } from "@tanstack/react-query";

import { getPracticeManagementTillageEmissionFactors } from "services";

import { PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_TILLAGE_EMISSION_FACTORS } from "consts";

export const usePracticeManagementTillageEmissionFactors = (version?: string, country: PracticeManagement.CountryCode = "global") =>
  useQuery({
    queryKey: [PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_TILLAGE_EMISSION_FACTORS, country, version],
    queryFn: async () => {
      const factors = await getPracticeManagementTillageEmissionFactors(version, country);
      return factors.map((factor) => ({
        ...factor,
        editingKey: factor.tillageId,
      }));
    },
    staleTime: 1000 * 60 * 60, // 1h
    gcTime: 1000 * 60 * 24,
  });
